module.exports = __webpack_public_path__ + "img/shape_triangle_l.a877ed3a.svg";